/**
 *
 * @exports b-toolkit-cache
 */
define('toolkit/b-toolkit/b-toolkit.cache', function (require, exports) {
	"use strict";

	var cache = {};

	exports.add = function (block) {
		var id = block.uniqid;

		if (!id) {
			return;
		}

		cache[id] = block;

	};

	exports.get = function (id) {
		return cache[id];
	};

	exports.has = function (id) {
		return cache[id] !== undefined;
	};

	exports.remove = function (id) {
		delete cache[id];
	};

	/**
	 * @desc get counts of all items
	 * @returns {Object} cache
	 */
	exports.getState = function () {
		var res = {},
			bemName;

		for(var key in cache){
			if(!cache.hasOwnProperty(key)){
				continue;
			}

			bemName = cache[key].bemName;

			if(!(bemName in res)){
				res[bemName] = 0;
			}

			res[bemName]++
		}

		return res;
	};

});
